__turbopack_context__.v({
  "buttonContainer": "FinanceQuoteRepaymentFrequencySwitch-module-scss-module__3I4rcG__buttonContainer",
  "container": "FinanceQuoteRepaymentFrequencySwitch-module-scss-module__3I4rcG__container",
  "header": "FinanceQuoteRepaymentFrequencySwitch-module-scss-module__3I4rcG__header",
  "selectedButton": "FinanceQuoteRepaymentFrequencySwitch-module-scss-module__3I4rcG__selectedButton",
  "toggleButton": "FinanceQuoteRepaymentFrequencySwitch-module-scss-module__3I4rcG__toggleButton",
});
